export default __webpack_public_path__ + "assets/0c1b6bffc1aa0b8fc753009ce068354b.jpeg";